<template>
  <div>
    <!-- Fields -->
    <div class="is-bordered-box-shadow-main ">
      <div class="cont-row-statstype"><TypeCategoryStats /></div>
      <div class="fields">
        <div v-for="(field, index) in fieldStatistics" :key="index">
          <span>{{ $t(field.name) }}</span>
          <StatisticField
            :data="field.data"
            :negative="field.isNegative"
            :category-ids="field.categoryIds"
            :coordinate-point="field.coordinatePoint"
            :general-name="field.generalName"
            :single-name="field.singleName"
          />
        </div>
      </div>
    </div>
    <!-- Top Five Categories -->
    <!--    <div class="top-five-container">-->
    <!--      <div class="top-five-title">-->
    <!--        categorias dentro de top 5-->
    <!--      </div>-->
    <!--      <TopFiveHorizontalScroll :categories="topFiveCategories" />-->
    <!--    </div>-->
    <!-- Player Categories -->
    <div class="categories-container">
      <nav class="level">
        <div class="level-left">
          <div class="title-section" id="categorias-posesion" v-observe-visibility="visibilityChanged">
            <span class="is-size-4-mobile categories-title has-text-centered-mobile"
              >{{ $t('table.possession.title') }}
            </span>
          </div>
        </div>
        <div class="level-right">
          <div class="cont-statstype"><TypeCategoryStats /></div>
          <BField class="is-hidden-mobile">
            <BRadioButton
              v-for="(option, index) in displayOptions"
              v-model="viewData"
              :native-value="option.value"
              :key="index"
            >
              <BIcon :icon="option.icon" />
            </BRadioButton>
          </BField>
        </div>
        <div class="columns is-mobile is-vcentered is-centered is-hidden-tablet">
          <div class="column is-11">
            <BField>
              <BSelect placeholder="-Tabla-" size="is-medium" v-model="viewData" expanded>
                <template v-for="(option, index) in options">
                  <option :key="`option-${index}`" :value="option.value">{{ $t(option.text) }}</option>
                </template>
              </BSelect>
            </BField>
          </div>
        </div>
      </nav>
      <!-- Categories Table -->
      <div v-if="viewData === 'table'">
        <DataTable
          :data="translatedTableData"
          :columns="getColumns()"
          :expandedRows="expandedRows"
          @showDetails="onShowDetails"
          @hideDetails="onHideDetails"
        />
        <DataMobileTable
          :data="translatedTableData"
          :columns="getColumns()"
          @showDetails="onShowDetails"
          @hideDetails="onHideDetails"
          @openSubcategory="onOpenSubcategory"
          @changeSubcategory="onChangeSubcategory"
        />
      </div>
      <!-- Categories Pie -->
      <div v-else-if="viewData === 'pie'">
        <PieChartsPosessionTeam :data="tableData" :type="player.position_id" />
      </div>
    </div>
  </div>
</template>

<script>
import StatisticField from '@/components/Elements/StatisticField';
import DataTable from '@/components/Elements/DataTable';
import TypeCategoryStats from '@/components/Elements/TypeCategoryStats';
import possessionDataTable from '@/data/player/possessionTableData';
// import TopFiveHorizontalScroll from '@/components/Elements/TopFiveHorizontalScroll';
import DataMobileTable from '@/components/Elements/DataMobileTable';
import PieChartsPosessionTeam from '@/components/Elements/PieChartsPosessionTeam';
import { categoriesDisplayOptions } from '@/utils/mixins/categoriesDisplayOptions';
import { mapGetters, mapMutations } from 'vuex';
const { columns } = possessionDataTable;
import {
  analisisDeJugadorSeccionVista,
  analisisDeJugadorCategoriasDeTabla,
  analisisDeJugadorTablaGrafica,
  analisisDeJugadorDetallesCategoria,
  analisisDeJugadorDetalleSubcategoria,
} from '@/utils/analytics/players';
import translatedTableDataMixin from '@/utils/mixins/translated-table-data';

export default {
  name: 'PlayerPossession',
  components: {
    // TopFiveHorizontalScroll,
    StatisticField,
    DataMobileTable,
    DataTable,
    PieChartsPosessionTeam,
    TypeCategoryStats,
  },
  mixins: [categoriesDisplayOptions, translatedTableDataMixin],
  data() {
    return {
      viewData: 'table',
      columns,
      // expandedRows,
      options: [
        { text: 'general.table', value: 'table' },
        { text: 'general.graph', value: 'pie' },
      ],
    };
  },
  beforeMount() {
    // if (this.player.position_id === 1) {
    //   this.expandedRows = goalkeeperExpandedRows;
    // }
  },
  watch: {
    // player(newValue) {
    //   // Check is player is a goalkeeper
    //   if (newValue && newValue.position_id === 1) {
    //     this.expandedRows = goalkeeperExpandedRows;
    //   }
    // },
    viewData(value) {
      analisisDeJugadorTablaGrafica(this.seasonId, this.teamId, this.playerId, this.section, value);
    },
    getBasePlaysStack: {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.length) {
          this.setPlaysForGames(newValue);
        }
      },
    },
  },
  computed: {
    ...mapGetters('playersPossession', ['fieldStatistics', 'tableData', 'topFiveCategories', 'getBasePlaysStack']),
    ...mapGetters('playersGeneral', ['player', 'playerId', 'teamId']),
    ...mapGetters({ seasonId: 'filterGeneral/getSeasonId', section: 'filterGeneral/getCategoryTypeName' }),
  },
  methods: {
    ...mapMutations('filterGeneral', ['setPlaysForGames']),
    visibilityChanged(isVisible, entry) {
      if (isVisible) {
        const sectionName = entry.target.id;
        analisisDeJugadorSeccionVista(this.seasonId, this.teamId, this.playerId, this.section, sectionName);
      }
    },
    getColumns() {
      return this.getTranslatedColumns(columns);
    },
    onShowDetails(category) {
      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, 'mostrar');
    },
    onHideDetails(category) {
      analisisDeJugadorCategoriasDeTabla(this.seasonId, this.teamId, this.playerId, category, this.section, 'ocultar');
    },
    onOpenSubcategory(category) {
      analisisDeJugadorDetallesCategoria(this.seasonId, this.teamId, this.playerId, this.section, category);
    },
    onChangeSubcategory(subcategory) {
      analisisDeJugadorDetalleSubcategoria(this.seasonId, this.teamId, this.playerId, this.section, subcategory);
    },
  },
};
</script>

<style scoped lang="scss">
.cont-row-statstype {
  width: 100%;
  height: 40px;
}
.cont-statstype {
  margin-right: 15px;
  @media screen and (max-width: 768px) {
    margin-bottom: 15px;
    margin-right: 0px;
  }
}
div.fields {
  padding-top: 30px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-radius: 20px;
}

@media screen and (max-width: 1334px) {
  div.fields {
    grid-template-columns: repeat(3, 1fr);

    & > div:last-child {
      grid-column-start: 2;
      grid-column-end: 3;
    }
  }
}

@media screen and (max-width: 962px) {
  div.fields {
    grid-template-columns: repeat(2, 1fr);

    & > div:last-child {
      grid-column-start: unset;
      grid-column-end: unset;
    }
  }
}

@media screen and (max-width: 656px) {
  div.fields {
    grid-template-columns: 1fr;
  }
}

.top-five-container {
  margin-top: 40px;
  margin-bottom: 40px;
  text-align: left;
}

.top-five-title {
  font-size: 30px;
  line-height: 1.85;
  color: #808285;
  text-transform: uppercase;
}

/* Categories section */
.categories-container {
  margin-top: 20px;
  margin-bottom: 20px;
}

.categories-title {
  font-size: 40px;
  line-height: 1.85;
  color: #808285;
  text-transform: uppercase;
}
</style>
